import { render, staticRenderFns } from "./LeadLovers.vue?vue&type=template&id=20299356&scoped=true&"
import script from "./LeadLovers.vue?vue&type=script&lang=js&"
export * from "./LeadLovers.vue?vue&type=script&lang=js&"
import style0 from "./LeadLovers.vue?vue&type=style&index=0&id=20299356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20299356",
  null
  
)

export default component.exports